import { HttpInsuranceProductService } from './../../../../service/http-insurance-product.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ResultListDto } from '../../../../service/dto';
import { ProductDto } from '../../../../service/dto-insurance';
import { finalize, Subscription } from 'rxjs';
import { Filter, OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-product-list',
	standalone: false,
	templateUrl: './product-list.component.html',
	styleUrl: './product-list.component.scss'
})
export class ProductListComponent implements OnInit, OnDestroy {
	data?: ResultListDto<ProductDto>;
	subscription = new Subscription();
	tableState: OnTableChange = { pageIndex: 0, pageSize: 0, filters: [] };

	loading = false;
	filters: Filter[] = [
	];
	columnRef: TableColumn[] = [
		{ "title": "Name", "property": "name" },
		{ "title": "Product Type", "property": "productType" },
		{ "title": "Benefit Type", "property": "benefitType" }
	];

	constructor(private httpService: HttpInsuranceProductService, private router: Router) {

	}
	ngOnInit(): void {
		this.doFetchResults({ pageIndex: 1, pageSize: 30, filters: [] });
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	doView(input: ProductDto) {
		this.router.navigate(['/product', input.id, 'view']);
	}
	doFetchResults(input: OnTableChange) {
		if (JSON.stringify(this.tableState) == JSON.stringify(input)) {
			return;
		}
		this.tableState = input;
		this.loading = true;



		this.httpService.getAll(this.tableState.pageIndex, this.tableState.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
}
